module.exports = __webpack_public_path__ + "fonts/VistaSansOT-Reg.2f16ca54.otf";